/** Predefined specializations for fire forensics experts. */
export const ALL_SPECIALIZATIONS = [
  'Arson Investigation',
  'Fire Cause & Origin',
  'Electrical Fire Investigation',
  'Wildfire Investigation',
  'Industrial Fire Investigation',
  'Explosion Investigation',
  'Insurance Claims Assessment',
  'Fire Safety Consulting',
  'Forensic Engineering',
  'Chemical Fire Analysis',
  'Vehicle Fire Investigation',
  'Residential Fire Investigation',
  'Commercial Fire Investigation',
  'High-Rise Fire Investigation',
  'Fire Pattern Analysis',
  'Smoke & Soot Analysis',
  'Structural Fire Damage Assessment',
  'Fire Reconstruction',
  'Expert Witness Testimony',
  'Hazardous Materials Investigation',
];
